<ion-content [fullscreen]="true">
  <div class="split-layout">

    <div class="side-image">
      <div class="image-overlay"></div>
    </div>

    <div class="side-form">
      <div class="auth-card-container">
        <div class="auth-section fade-in">
          @if(section === 'set_org') {
          <div class="auth-header">
            <h2 class="auth-title">{{'PAGES.LOGIN.SET_ORG.TITLE' | translate}}</h2>
            <p class="auth-subtitle">{{'PAGES.LOGIN.SET_ORG.SUBTITLE' | translate}}</p>
          </div>
          <form [formGroup]="setOrgForm" class="auth-form-stack">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="soft-input">
              <mat-label>{{'PAGES.LOGIN.FORM.CUSTOMER.LABEL' | translate}}</mat-label>
              <mat-select formControlName="customer" (selectionChange)="loadOrgs($event.value)"
                panelClass="soft-select-panel">
                @for (customer of customersList; track customer.id) {
                <mat-option [value]="customer.id">{{customer.businessName}}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="soft-input">
              <mat-label>{{'PAGES.LOGIN.FORM.ORGANIZATION.LABEL' | translate}}</mat-label>
              <mat-select formControlName="organization" [disabled]="organizationsList.length < 1"
                panelClass="soft-select-panel">
                @for (organization of organizationsList; track organization.id) {
                <mat-option [value]="organization.id">{{organization.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <ion-button expand="block" mode="md" class="auth-btn primary-btn" (click)="setOrgAndNavigateForward()">
              {{'PAGES.LOGIN.SET_ORG.CTA' | translate}}
            </ion-button>
          </form>
          }
          @else if(section === 'forgot_pw') {
          <div class="auth-header">
            <h2 class="auth-title">{{'PAGES.LOGIN.FORGOT_PASSWORD.TITLE' | translate}}</h2>
            <p class="auth-subtitle">{{'PAGES.LOGIN.FORGOT_PASSWORD.SUBTITLE' | translate}}</p>
          </div>

          <form [formGroup]="forgotPwForm" class="auth-form-stack">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="soft-input">
              <mat-label>{{'PAGES.LOGIN.FORM.EMAIL.LABEL' | translate}}</mat-label>
              <input matInput formControlName="email" type="email">
              <mat-icon matSuffix class="input-icon">mail_outline</mat-icon>
            </mat-form-field>
            <ion-button expand="block" mode="md" class="auth-btn primary-btn" (click)="sendResetPwMail()">
              {{'PAGES.LOGIN.SEND_MAIL' | translate}}
            </ion-button>
          </form>

          <div class="back-to-login">
            <a routerLink="/auth/login" class="auth-link-bold">
              <mat-icon>arrow_back</mat-icon> {{'PAGES.LOGIN.RETURN_TO_LOGIN' | translate}}
            </a>
          </div>

          }
          @else if(section === 'set_pw' || section === 'reset_pw') {
          <div class="auth-header">
            <h2 class="auth-title">
              {{ (section === 'reset_pw' ? 'PAGES.LOGIN.RESET_PASSWORD.TITLE' : 'PAGES.LOGIN.SET_PASSWORD.TITLE') |
              translate}}
            </h2>
          </div>

          <form [formGroup]="setResetPwForm" class="auth-form-stack">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="soft-input">
              <mat-label>{{'PAGES.LOGIN.FORM.PASSWORD.LABEL' | translate}}</mat-label>
              <input matInput formControlName="password" [type]="showPassword ? 'text' : 'password'"
                [placeholder]="'PAGES.LOGIN.FORM.PASSWORD.PLACEHOLDER' | translate">

              <mat-icon matSuffix class="input-icon" style="cursor: pointer;"
                (click)="showPassword = !showPassword">{{showPassword ?
                'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="soft-input">
              <mat-label>{{'PAGES.LOGIN.FORM.CONFIRM_PASSWORD.LABEL' | translate}}</mat-label>
              <input matInput formControlName="confirmPassword" [type]="showPassword ? 'text' : 'password'">
            </mat-form-field>

            <ion-button expand="block" mode="md" class="auth-btn primary-btn"
              (click)="section === 'reset_pw' ? resetPw() : setPw()">
              {{ (section === 'reset_pw' ? 'PAGES.LOGIN.RESET_PASSWORD.BUTTON' : 'PAGES.LOGIN.SET_PASSWORD.BUTTON') |
              translate}}
            </ion-button>
          </form>

          <div class="back-to-login">
            <a routerLink="/auth/login" class="auth-link-bold">
              <mat-icon>arrow_back</mat-icon> {{'PAGES.LOGIN.RETURN_TO_LOGIN' | translate}}
            </a>
          </div>

          }
          @else {
          <div class="auth-header">
            <h2 class="auth-title">{{'PAGES.LOGIN.TITLE' | translate}}</h2>
            <p class="auth-subtitle">Benvenuto, inserisci le tue credenziali</p>
          </div>

          <form [formGroup]="authForm" class="auth-form-stack">

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="soft-input">
              <mat-label>{{'PAGES.LOGIN.FORM.EMAIL.LABEL' | translate}}</mat-label>
              <input matInput formControlName="email" type="email"
                [placeholder]="'PAGES.LOGIN.FORM.EMAIL.PLACEHOLDER' | translate">
              <mat-icon matSuffix class="input-icon">mail_outline</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="soft-input">
              <mat-label>{{'PAGES.LOGIN.FORM.PASSWORD.LABEL' | translate}}</mat-label>
              <input matInput formControlName="password" [type]="showPassword ? 'text' : 'password'"
                [placeholder]="'PAGES.LOGIN.FORM.PASSWORD.PLACEHOLDER' | translate">

              <mat-icon matSuffix class="input-icon" style="cursor: pointer;"
                (click)="showPassword = !showPassword">{{showPassword ?
                'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>

            <div class="forgot-password-row">
              <a routerLink="/auth/login" fragment="forgot_pw" class="auth-link">
                {{'PAGES.LOGIN.FORGOT_PASSWORD.QUESTION' | translate}}
              </a>
            </div>

            <ion-button expand="block" mode="md" class="auth-btn primary-btn" (click)="submitCredentials()">
              {{'PAGES.LOGIN.LOGIN' | translate}}
            </ion-button>
          </form>
          }
        </div>
      </div>
    </div>
  </div>
</ion-content>
